import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { EventCustom } from '../enum/event-custom.enum';
import { EventName } from '../enum/event-name.enum';
import { ICountry } from '../interfaces/country.interface';
import { StateConfig } from '../interfaces/state-config.interface';
import { STATE_CONFIG } from '../config/state.config';
import { CDN_CONFIG } from '../config/tokens.config';

/**
 * Initials config
 * @param countryService CountryService
 * @returns () => Promise<ICountry[]>
 */
export function initialCountry(countryService: CountryService) {
    return () => countryService.get();
}

@Injectable({ providedIn: 'root' })
export class CountryService {
    /**
     * Creates an instance of country service.
     * @param cdn string
     * @param stateConfig StateConfig
     */
    constructor(
        @Inject(CDN_CONFIG) private cdn: string,
        @Inject(STATE_CONFIG) private stateConfig: StateConfig
    ) {}
    /**
     * Gets country service
     * @returns  Promise<ICountry[]>
     */
    async get() {
        const response = await fetch(
            `${this.cdn}/config-front/countries.json`,
            {
                method: 'GET',
            }
        );

        let country: any[] = await response.json();

        country = country
            .map(
                (item: any) =>
                    ({
                        id: item.code,
                        code: item.dial_code,
                        name: item.name_es.trim(),
                    } as ICountry)
            )
            .sort((a, b) => (a.name > b.name ? 1 : -1));

        this.stateConfig.set({
            eventCustom: EventCustom.GLOBAL,
            eventName: EventName.COUNTRY,
            data: country,
        });

        return country;
    }
    /**
     * Gets by id
     * @param id string
     * @returns ICountry
     */
    getById(id: string): ICountry {
        const countries = this.stateConfig.get(
            EventCustom.GLOBAL,
            EventName.COUNTRY
        )?.data as ICountry[];
        return countries.find((x) => x.id === id);
    }
}
